import React from "react";
import {
  getBezierPath,
  getEdgeCenter,
  getMarkerEnd,
  useReactFlow
} from "react-flow-renderer";
import "./css/buttonedge.css";
import { Delete } from "@mui/icons-material";

export default function RemoveEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  arrowHeadType,
  markerEndId
}) {
  const { setEdges } = useReactFlow();

  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  const markerEnd = markerEndId ? `url(#${markerEndId})` : null;

  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY
  });

  const foreignObjectSize = 40;

  const onEdgeClick = (evt) => {
    evt.stopPropagation();
    setEdges((eds) => eds.filter((e) => e.id !== id));
  };

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      <foreignObject
        width={foreignObjectSize}
        height={foreignObjectSize}
        x={edgeCenterX - foreignObjectSize / 2}
        y={edgeCenterY - foreignObjectSize / 2}
        className="edgebutton-foreignobject"
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <body>
          <button
            className="edgebutton"
            onClick={onEdgeClick}
            title="Remover conexão"
          >
            <Delete sx={{ width: "12px", height: "12px", color: "#9A00ED" }} />
          </button>
        </body>
      </foreignObject>
    </>
  );
}
